(function () {
  'use strict';

  const dimensions = {
    'filter.p.m.custom.collection_types': 'categories',
    'filter.p.m.custom.collection_subtypes_list': 'subtypes',
    'filter.p.product_type': 'type',
    'filter.p.m.custom.vehicle_areas': 'areas'
  };
  const values = value => (Array.isArray(value) ? value : [value]).filter(item => item != null && String(item).trim());
  function normalize(value) {
    const named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };
    return String(value == null ? '' : value).replace(/&(#x[0-9a-f]+|#[0-9]+|amp|lt|gt|quot|apos|nbsp);/gi, (entity, key) => {
      if (key[0] !== '#') return named[key.toLowerCase()];
      const hex = key[1].toLowerCase() === 'x';
      const code = parseInt(key.slice(hex ? 2 : 1), hex ? 16 : 10);
      return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff) ? String.fromCodePoint(code) : entity;
    }).trim().replace(/\s+/g, ' ').toLowerCase();
  }
  function selectedFilters(source, operators = {}) {
    const params = new URL(source).searchParams;
    return Object.entries(dimensions).map(([key, field]) => ({
      field,
      values: [...new Set(params.getAll(key).map(normalize).filter(value => value && !(field === 'type' && value === 'parts bundle')))],
      operator: normalize(operators[key]) === 'and' ? 'and' : 'or'
    })).filter(filter => filter.values.length);
  }
  function needsComponentLookup(source) {
    const types = new URL(source).searchParams.getAll('filter.p.product_type').map(normalize).filter(Boolean);
    return types.length > 0 && !types.includes('parts bundle');
  }
  function matchesProduct(product, filters) {
    return !filters.length || Array.isArray(product.components) && product.components.some(component => filters.every(filter => {
      const actual = new Set(values(component[filter.field]).map(normalize));
      return filter.operator === 'and' ? filter.values.every(value => actual.has(normalize(value))) : filter.values.some(value => actual.has(normalize(value)));
    }));
  }
  function requestUrl(collectionUrl, sectionId, page, source) {
    const current = new URL(source);
    const url = new URL(current);
    const base = new URL(collectionUrl, current.origin);
    if (base.origin !== current.origin) throw new Error('Invalid collection origin');
    const tags = current.pathname.match(/\/collections\/[^/]+\/([^/]+)\/?$/)?.[1]?.split('+') || [];
    if (!tags.includes('parts-bundle')) tags.push('parts-bundle');
    const currentCollectionPath = current.pathname.match(/^(.*\/collections\/[^/]+)/)?.[1];
    url.pathname = (currentCollectionPath || base.pathname.replace(/\/$/, '').replace(/\/parts-bundle$/, '')) + '/' + tags.join('+');
    Object.keys(dimensions).forEach(key => url.searchParams.delete(key));
    url.searchParams.delete('sections');
    url.searchParams.set('filter.p.product_type', 'Parts Bundle');
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));
    url.hash = '';
    return url;
  }
  function uniqueMatches(products, existingIds, filters) {
    const seen = new Set([...existingIds].map(String));
    return products.filter(product => {
      const id = String(product.id || '');
      if (!id || seen.has(id) || !matchesProduct(product, filters)) return false;
      seen.add(id);
      return true;
    });
  }
  function sortCompare(sort) {
    const direction = /-descending$/.test(sort) ? -1 : 1;
    if (/^price-/.test(sort)) return (a, b) => direction * (Number(a.dataset.productPrice) - Number(b.dataset.productPrice));
    if (/^title-/.test(sort)) return (a, b) => direction * a.dataset.productTitle.localeCompare(b.dataset.productTitle);
    if (/^created-/.test(sort)) return (a, b) => direction * (Number(a.dataset.productCreated) - Number(b.dataset.productCreated));
    return null;
  }
  function planCardRequests(matches) {
    const blocks = new Map();
    matches.forEach(product => {
      const position = Number(product.position);
      if (!Number.isInteger(position) || position < 1 || position > 25000) throw new Error('Invalid bundle position');
      const densePage = Math.ceil(position / 24);
      const smallPage = Math.ceil(position / 4);
      if (!blocks.has(densePage)) blocks.set(densePage, new Map());
      const pages = blocks.get(densePage);
      if (!pages.has(smallPage)) pages.set(smallPage, new Set());
      pages.get(smallPage).add(String(product.id));
    });
    return [...blocks.keys()].sort((a, b) => a - b).flatMap(page => {
      const pages = blocks.get(page);
      // Four small pages already render at least 16 rows. A single 24-row batch
      // saves at least three requests while adding at most eight unused rows.
      if (pages.size >= 4) return [{ page, pageSize: 24, ids: [...pages.values()].flatMap(ids => [...ids]) }];
      return [...pages.keys()].sort((a, b) => a - b).map(smallPage => ({ page: smallPage, pageSize: 4, ids: [...pages.get(smallPage)] }));
    });
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { needsComponentLookup, selectedFilters, matchesProduct, requestUrl, uniqueMatches, sortCompare, planCardRequests };
    return;
  }
  if (window.PartifyCollectionBundleResults) { window.PartifyCollectionBundleResults.refresh(); return; }

  let state;
  let queued = false;
  const indexCache = new Map();
  const indexCacheTtl = 60000;
  const cardPageSize = 4;
  const gridSelector = '[data-productgrid-items]';
  function metadata(card) {
    const script = card.querySelector('[data-bundle-components]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (_) { return null; }
  }
  function readConfig(root) {
    const script = root?.querySelector('[data-bundle-results-config]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (_) { return null; }
  }
  function nativeCards(root) {
    return [...root.querySelectorAll(gridSelector + ' > [data-product-item]')].filter(card => !card.hasAttribute('data-partify-injected-bundle'));
  }
  function restore(root) {
    root.querySelectorAll('[data-partify-injected-bundle], [data-bundle-generated-grid]').forEach(node => node.remove());
    root.querySelectorAll('[data-bundle-component-hidden]').forEach(node => node.removeAttribute('data-bundle-component-hidden'));
    root.querySelectorAll('[data-bundle-hidden-empty]').forEach(node => { node.hidden = false; node.removeAttribute('data-bundle-hidden-empty'); });
  }
  function stillCurrent(run) {
    if (state !== run || run.controller.signal.aborted || !run.root.isConnected || location.href !== run.source) return false;
    return (run.root.querySelector(gridSelector) || run.root.querySelector('.productgrid--no-results')) === run.target;
  }
  function endpointUrl(config, kind, page, source) {
    return requestUrl(config.collectionUrl, kind === 'index'
      ? (config.indexSectionId || 'partify-bundle-index')
      : kind === 'dense'
        ? (config.denseCardSectionId || 'partify-bundle-cards-dense')
        : (config.cardSectionId || 'partify-bundle-cards'), page, source);
  }
  function indexKey(config, source) {
    return endpointUrl(config, 'index', 1, source).href + '|' + String(window.Shopify?.currency?.active || '');
  }
  async function fetchDocument(url, run) {
    const timeout = setTimeout(() => run.controller.abort(), 10000);
    try {
      const response = await fetch(url, { signal: run.controller.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Bundle results unavailable');
      const markup = await response.text();
      run.metrics.requests++;
      run.metrics.htmlBytes += new TextEncoder().encode(markup).length;
      return new DOMParser().parseFromString(markup, 'text/html');
    } finally { clearTimeout(timeout); }
  }
  function endpointConfig(doc, selector, config, page, expectedPageSize = cardPageSize) {
    const script = doc.querySelector(selector);
    if (!script) throw new Error('Missing bundle response');
    const data = JSON.parse(script.textContent);
    if (Number(data.page) !== page || Number(data.cardPageSize) !== expectedPageSize ||
      String(data.collectionId) !== String(config.collectionId)) throw new Error('Invalid bundle response');
    return data;
  }
  async function fetchIndex(config, run) {
    const key = indexKey(config, run.source);
    run.indexKey = key;
    const cached = indexCache.get(key);
    if (cached && Date.now() - cached.at < indexCacheTtl) {
      run.metrics.indexCacheHit = true;
      return cached.products;
    }
    indexCache.delete(key);
    const products = [];
    const seenPages = new Set();
    let page = 1;
    while (page) {
      if (seenPages.has(page)) throw new Error('Repeated bundle index page');
      seenPages.add(page);
      const doc = await fetchDocument(endpointUrl(config, 'index', page, run.source), run);
      if (!stillCurrent(run)) return [];
      const data = endpointConfig(doc, '[data-bundle-index-config]', config, page);
      for (const entry of doc.querySelectorAll('[data-bundle-index-position]')) {
        const product = metadata(entry);
        const position = Number(entry.getAttribute('data-bundle-index-position'));
        if (!product?.id || !Array.isArray(product.components) || !Number.isInteger(position) || position < 1 || position > 25000) throw new Error('Invalid bundle index item');
        products.push({ ...product, position, cardPage: Math.ceil(position / cardPageSize) });
      }
      const next = Number(data.nextPage);
      page = Number.isInteger(next) && next > page ? next : null;
    }
    if (!stillCurrent(run)) return [];
    indexCache.set(key, { at: Date.now(), products });
    while (indexCache.size > 8) indexCache.delete(indexCache.keys().next().value);
    return products;
  }
  async function fetchMatchingCards(config, matches, run) {
    const jobs = planCardRequests(matches);
    const cards = new Map();
    let cursor = 0;
    async function worker() {
      while (cursor < jobs.length) {
        if (!stillCurrent(run)) return;
        const job = jobs[cursor++];
        const doc = await fetchDocument(endpointUrl(config, job.pageSize === 24 ? 'dense' : 'cards', job.page, run.source), run);
        if (!stillCurrent(run)) return;
        const root = doc.querySelector('[data-bundle-card-results]');
        if (!root) throw new Error('Missing bundle cards');
        endpointConfig(root, '[data-bundle-card-config]', config, job.page, job.pageSize);
        const expected = new Set(job.ids);
        const found = new Set();
        for (const card of root.querySelectorAll(gridSelector + ' > [data-product-item]')) {
          const product = metadata(card);
          if (!product || String(product.id) !== card.dataset.productId || !expected.has(String(product.id))) continue;
          found.add(String(product.id));
          cards.set(String(product.id), { ...product, card });
        }
        // A changing sort/catalog must never cause a different product to be imported.
        if ([...expected].some(id => !found.has(id))) throw new Error('Bundle catalog changed while loading');
      }
    }
    await Promise.all(Array.from({ length: Math.min(2, jobs.length) }, worker));
    return matches.map(product => cards.get(String(product.id))).filter(Boolean);
  }
  function prepareCard(product, source) {
    const card = document.importNode(product.card, true);
    card.dataset.partifyInjectedBundle = '';
    card.removeAttribute('data-bundle-component-hidden');
    // Native product JSON is required by purchase/compare controls; executable scripts are never imported.
    card.querySelectorAll('script').forEach(script => { if (script.type !== 'application/json') script.remove(); });
    const preview = new URL(source).searchParams.get('preview_theme_id');
    if (preview) card.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), source);
      if (url.origin === location.origin && url.pathname.includes('/products/')) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    });
    return card;
  }
  function insertProducts(run, products, config) {
    let grid = run.root.querySelector(gridSelector);
    if (!products.length) return;
    if (!grid) {
      grid = document.createElement('ul');
      grid.className = 'productgrid--items products-per-row-' + (config.columns === '3' || config.columns === 3 ? '3' : '4');
      grid.dataset.html = 'productgrid-items';
      grid.dataset.productgridItems = '';
      grid.dataset.bundleGeneratedGrid = '';
      const empty = run.root.querySelector('.productgrid--no-results');
      if (!empty) return;
      empty.before(grid);
      empty.hidden = true;
      empty.dataset.bundleHiddenEmpty = '';
    }
    const compare = sortCompare(new URL(run.source).searchParams.get('sort_by') || '');
    products.forEach(product => {
      const card = prepareCard(product, run.source);
      if (compare) {
        const next = [...grid.children].find(node => node.matches('[data-product-item]') && !node.hasAttribute('data-bundle-component-hidden') && compare(card, node) < 0);
        if (next) next.before(card); else grid.append(card);
      } else {
        grid.append(card);
      }
    });
    run.target = grid;
    grid.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
    window.PartifyCollectionPurchase?.scan();
    window.PartifyCollectionCountryFilter?.apply(run.root);
    try {
      if (window.Wishlist?.getIds) document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: window.Wishlist.getIds() } }));
      window.yotpo?.refreshWidgets?.();
    } catch (_) { /* Optional third-party widgets must not interrupt product results. */ }
    document.dispatchEvent(new CustomEvent('partify:bundle-results-ready', { detail: { count: products.length } }));
  }
  async function refresh() {
    const root = document.querySelector('[data-productgrid-outer]');
    const config = readConfig(root);
    if (!root || !config) { state?.controller.abort(); state = null; return; }
    const source = location.href;
    const filters = selectedFilters(source, config.operators);
    const page = Number(new URL(source).searchParams.get('page') || 1);
    const target = root.querySelector(gridSelector) || root.querySelector('.productgrid--no-results');
    const cards = nativeCards(root);
    const ids = cards.map(card => card.dataset.productId).join(',');
    if (state && !state.controller.signal.aborted && state.root === root && state.target === target && state.source === source && state.nativeIds === ids && state.firstCard === cards[0]) return;
    state?.controller.abort();
    restore(root);
    const run = { root, source, target: root.querySelector(gridSelector) || root.querySelector('.productgrid--no-results'), nativeIds: ids, firstCard: cards[0], controller: new AbortController(), metrics: { requests: 0, htmlBytes: 0, startedAt: Date.now(), indexCacheHit: false } };
    state = run;
    if (!needsComponentLookup(source) || !filters.length || !run.target) return;
    const nativeIds = new Set(cards.map(card => card.dataset.productId));
    if (page !== 1) return;
    root.dataset.bundleResultsState = 'loading';
    try {
      const index = await fetchIndex(config, run);
      if (!stillCurrent(run)) return;
      const candidates = uniqueMatches(index, nativeIds, filters);
      const fetched = await fetchMatchingCards(config, candidates, run);
      const matches = uniqueMatches(fetched, nativeIds, filters);
      if (!stillCurrent(run)) return;
      insertProducts(run, matches, config);
      root.dataset.bundleResultsState = 'ready';
      root.dataset.bundleResultsAdded = String(matches.length);
      root.dataset.bundleLoadingMetrics = JSON.stringify({ requests: run.metrics.requests, htmlBytes: run.metrics.htmlBytes, milliseconds: Date.now() - run.metrics.startedAt, indexCacheHit: run.metrics.indexCacheHit, added: matches.length });
    } catch (error) {
      if (state === run) {
        run.controller.abort();
        if (run.indexKey) indexCache.delete(run.indexKey);
        root.dataset.bundleResultsState = 'error';
        if (error.name !== 'AbortError') console.warn('Parts bundle results could not be loaded.', error);
      }
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }
  function relevantNode(node) {
    if (node.nodeType !== 1 || node.hasAttribute('data-partify-injected-bundle') || node.hasAttribute('data-bundle-generated-grid')) return false;
    return node.matches('[data-productgrid-outer], [data-productgrid-items], .productgrid--no-results, [data-product-item]') || !!node.querySelector('[data-productgrid-outer], [data-productgrid-items], .productgrid--no-results');
  }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevantNode))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('partify:damage-ready', schedule);
  document.addEventListener('partify:bundles:refresh', schedule);
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  window.PartifyCollectionBundleResults = { refresh: schedule };
  schedule();
})();
